<template>
  <div class="panel">
    <div class="panel-heading">
      <h3 class="panel-title text-center">
        Прогресс обучения
        <i
          class="icon md-help-outline cursor-pointer"
          aria-hidden="true"
          data-toggle="popover"
          data-html="true"
          data-trigger="click | hover"
          data-content="Высчитывается из количества сданных экзаменов"
        ></i>
      </h3>
    </div>
    <div class="panel-body">
      <div class="report-content" style="width: 100%">
        <span v-if="loading" class="error loading status_padding">
          <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>Загрузка
          данных...
        </span>

        <span v-else-if="error" class="error status_padding">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Ошибка
          загрузки данных
        </span>

        <span v-else-if="isStatsEmpty">
          <p class="error no-data-message">Нет данных для статистики</p>
        </span>
        <GChart
          v-else
          type="PieChart"
          :data="chartData"
          :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  name: "UserPassDiagram",
  data() {
    return {
      loading: true,
      error: false,
      times: [],
      chartOptions: {
        legend: { position: "bottom" },
        width: "100%",
        height: 400,
        pieHole: 0.4,
        colors: ["#51b53f", "#e0e0e0"],
      },
    };
  },
  computed: {
    chartData() {
      return [["c0", "c1"], ...this.times];
    },
    isDataEmpty() {
      return this.times.length === 0;
    },
    isPointsEmpty() {
      return this.times.every((point) => {
        return point[1] === 0;
      });
    },
    isStatsEmpty() {
      return this.isDataEmpty || this.isPointsEmpty;
    },
  },
  components: {
    GChart,
  },
  methods: {
    get_data() {
      axios
        .get("/widgets/UserPass")
        .then((response) => {
          this.times = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
        });
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.md-help-outline {
  color: #ff6611;
}
.error,
.loading {
  display: inline-block;
}
.error i,
.loading i {
  margin-right: 5px;
}

.error {
  font-weight: bold;
}
</style>
